const subMenuBtn = () => {
    const menu = document.querySelector('.menu');
    if (!menu) return;

    const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
    const candidates = Array.from(
        menu.querySelectorAll(
            '.menu_sup a, .sidebar_profile_links a, .sidebar_notifications',
        ),
    )
        .map((link) => {
            const url = new URL(link.href, window.location.origin);
            return {
                link,
                url,
                path: url.pathname.replace(/\/+$/, '') || '/',
            };
        })
        .filter(({ url, path }) => {
            return (
                url.origin === window.location.origin &&
                (currentPath === path ||
                    (path !== '/' && currentPath.startsWith(`${path}/`)))
            );
        })
        .sort((first, second) => second.path.length - first.path.length);

    if (candidates.length) {
        const activeLink = candidates[0].link;
        activeLink.setAttribute('aria-current', 'page');
        const activeItem = activeLink.closest('.menu_item_container');
        if (activeItem) activeItem.classList.add('is-active');

        const activeGroup = activeLink.closest('.aforos_group');
        if (activeGroup) activeGroup.classList.add('is-active');

        const activeProfile = activeLink.closest('.sidebar_profile');
        if (activeProfile) activeProfile.classList.add('is-active');
    }

    const toggle = document.getElementById('aforos_submenu');
    const links = document.getElementById('aforos_links');
    if (!toggle || !links) return;
    toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        links.hidden = expanded;
    });
};
export default subMenuBtn;
